<template>
    <b-card-text>
      <b-row>
        <b-col>
          <b-form-input
            v-model="input_filter"
            placeholder="Filter..."
            class="mb-3"
          ></b-form-input>

          <Maps
            :items="filter(input_filter, slot_items.items)"
            :input="input"
            :item_slot="item_slot"
            class="mb-3"
          ></Maps>
        </b-col>
      </b-row>
    </b-card-text>
</template>

<script>
import Maps from './Maps.vue'

export default {
  name: 'MapTab',
  data() {
    return {
      input_filter: ''
    }
  },
  props: {
    slot_items: Object,
    input: Object,
    item_slot: String
  },
  components: {
    Maps
  },
  methods: {
    filter: function(needle, haystack) {
			return haystack.filter(i => i.toUpperCase().includes(needle.toUpperCase()))
    }
  }
}
</script>